import React from "react";
import DropdownMenu from "components/dropdownMenu";
import { translate } from "reducers/i18n";
import { FiDownload } from "react-icons/fi";

const DownloadMessage = ({ handleDownload, showEml, showZip }) => {
  return (
    !showEml && !showZip ? (
      <button
        tabIndex="0"
        className={`button px-2`}
        title={translate("message_downloadMessage")}
        onClick={() => handleDownload("pdf")}
      >
        <span tabIndex="0" className="button p-1 border-rounded">
          <FiDownload /> {translate("message_downloadMessage")}
        </span>
      </button>
    ) : (
      <DropdownMenu
        dropdownClassName="dropdown-container left-0 border-top"
        style={{
          marginTop: "10px",
          marginRight: "10px",
          display: "inline-block",
        }}
        buttonClassName="bg-white text-black button d-block"
        svgClassName="d-none"
        buttonChildren={
          <span tabIndex="0" className="button p-1 border-rounded">
            <FiDownload /> {translate("message_downloadMessage")}
          </span>
        }
        closeOnClick
      >
        {[
          ...(showEml
            ? [{ val: "eml", translation: "message_downloadMessage_eml" }]
            : []),
          { val: "pdf", translation: "message_downloadMessage_pdf" },
          ...(showZip
            ? [{ val: "message_archive", translation: "message_downloadMessage_zip" }]
            : []),
        ].map((btn, i) => {
          return (
            <li
              key={i}
              tabIndex="0"
              className="dropdownMenu-list"
              style={{ transition: "all .3s" }}
              title=""
              onClick={() => handleDownload(btn.val)}
              onMouseOver={(e) => {
                e.stopPropagation();
                e.target.style.background = "#f2f2f2";
              }}
              onMouseLeave={(e) => {
                e.stopPropagation();
                e.target.style.background = "#fff";
              }}
            >
              <FiDownload className="mr-1" /> {translate(btn.translation)}
            </li>
          );
        })}
      </DropdownMenu>
    )
  );
};

export default DownloadMessage;
